export default {
  title: 'Modelos de Referencia',
  createButton: 'Crear Modelo de Referencia',
  searchLabel: 'Buscar',
  headers: {
    categoryName: 'Nombre de Categoría',
    codename: 'Código',
    pkl: 'PKL',
    pklSize: 'Tamaño PKL',
    modified: 'Modificado',
    actions: 'Acciones',
    disabled: 'Deshabilitado',
    status: 'Estado'
  },
  tooltips: {
    edit: 'Editar Modelo de Referencia',
    delete: 'Eliminar Modelo de Referencia',
    updateCustomModels: 'Actualizar Modelos Personalizados existentes'
  },
  deleteDialog: {
    title: 'Advertencia',
    message: 'Eliminando Modelo de Referencia:',
    confirmation: 'Esta acción no se puede deshacer. ¿Estás seguro?',
    cancel: 'Cancelar',
    delete: 'Eliminar'
  },
  updateDialog: {
    title: 'Advertencia',
    message: 'Actualizando Modelos Personalizados existentes para el Modelo de Referencia:',
    confirmation: 'Esta acción no se puede deshacer. ¿Estás seguro?',
    cancel: 'Cancelar',
    update: 'Actualizar'
  }
}
